import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateInput = ({ isRequired = false,valueSelect = '', field = '', label, type = 'text', id, placeholder = '', value = '', onChange = () => '' }) => {
    return (
        <>
            <div className="lbl-input">
                <span> {label} </span>
                <DatePicker selected={value} onChange={onChange} dateFormat='dd/MM/yyyy' />
                <input
                    className="input-required"
                    value={valueSelect}
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0 }}
                    required={isRequired} />
            </div>
        </>
    );
}

export { DateInput };
